const loadStudios = async (component) => {
  component.studios = await component.fetchStudios()
}

export default loadStudios
